export const SCAN_TICKET_STEP_SCAN_QR = 'SCAN_QR'
export const SCAN_TICKET_STEP_TICKET_INFO = 'TICKET_INFO'
export const SCAN_TICKET_STEP_SUCCESS = 'SUCCESS'

export const SCAN_TICKET = 'SCAN_TICKET'
export const SCAN_TICKET_SUCCESS = 'SCAN_TICKET_SUCCESS'

export const GET_SCANTICKET_LOCATION = 'GET_SCANTICKET_LOCATION'
export const GET_SCANTICKET_LOCATION_SUCCESS = 'GET_SCANTICKET_LOCATION_SUCCESS'
export const CLEAR_SCANTICKET = 'CLEAR_SCANTICKET'

export const REDEEM_SCANTICKET_PROMO = 'REDEEM_SCANTICKET_PROMO'
export const REDEEM_SCANTICKET_PROMO_SUCCESS = 'REDEEM_SCANTICKET_PROMO_SUCCESS'

export const REMOVE_SCANTICKET_PROMO = 'REMOVE_SCANTICKET_PROMO'

export const BUY_SCANTICKET = 'BUY_SCANTICKET'
